module.exports = __webpack_public_path__ + "img/section10_en.c629796.png";